import { useEffect, useState } from "react";
import axios from "axios";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
import { Button } from "./ui/button";
import { Paperclip, Send, ChevronLeft } from "lucide-react";

const clean = (h) => (h || "").replace(/&nbsp;/g, " ").replace(/\u00a0/g, " ");

const EmailPreviewDialog = ({ open, onOpenChange, smtp, to, cc, bcc, subject, body, attachments, onConfirm, sending, lang = "fr" }) => {
  const sigHtml = smtp?.signature ? (/<[a-z][^>]*>/i.test(smtp.signature) ? smtp.signature : smtp.signature.replace(/\n/g, "<br>")) : "";
  const bodyHtml = /<[a-z][^>]*>/i.test(body || "") ? body : (body || "").replace(/\n/g, "<br>");
  const [brandedHtml, setBrandedHtml] = useState("");
  useEffect(() => {
    if (!open) return;
    setBrandedHtml("");
    axios.post(`${API}/followup/preview`, { body: clean(body || ""), language: lang }).then((r) => setBrandedHtml(r.data.html)).catch(() => {});
  }, [open, body, lang]);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="email-preview-dialog">
        <DialogHeader><DialogTitle className="font-heading">Aperçu avant envoi</DialogTitle></DialogHeader>
        <div className="text-sm space-y-1 border rounded-lg p-3 bg-muted/30">
          <p><span className="text-muted-foreground w-12 inline-block">De :</span> {smtp?.from_name ? `${smtp.from_name} <${smtp.from_email}>` : smtp?.from_email}</p>
          <p data-testid="preview-to"><span className="text-muted-foreground w-12 inline-block">À :</span> {to}</p>
          {cc && <p><span className="text-muted-foreground w-12 inline-block">Cc :</span> {cc}</p>}
          {bcc && <p><span className="text-muted-foreground w-12 inline-block">Cci :</span> {bcc}</p>}
          <p data-testid="preview-subject"><span className="text-muted-foreground w-12 inline-block">Objet :</span> <strong>{subject}</strong></p>
        </div>
        {brandedHtml ? (
          <iframe title="Aperçu de l'e-mail" srcDoc={brandedHtml} sandbox="" className="w-full h-[52vh] border rounded-lg bg-[#f1f5f9]" data-testid="preview-body" />
        ) : (
          <div className="border rounded-lg p-4 bg-white text-neutral-900 prose prose-sm max-w-none" data-testid="preview-body">
            <div dangerouslySetInnerHTML={{ __html: clean(bodyHtml) }} />
            {sigHtml && <div className="mt-4 pt-3 border-t text-neutral-600" dangerouslySetInnerHTML={{ __html: clean(sigHtml) }} />}
          </div>
        )}
        <p className="text-xs text-muted-foreground" data-testid="preview-brand-note">L'e-mail est envoyé avec les logos Kintsugi TCC et Cabinet Alésia Thérapie, la signature du Cabinet et la mention RGPD.</p>
        {attachments?.length > 0 && (
          <div className="flex flex-wrap gap-2">
            {attachments.map((f, i) => (
              <span key={`${f.name}-${i}`} className={`inline-flex items-center gap-1 text-xs px-2 py-1 rounded ${f.kind === "module" ? "bg-violet-100 text-violet-800 dark:bg-violet-950 dark:text-violet-200" : f.kind === "analysis" ? "bg-sky-100 text-sky-800 dark:bg-sky-950 dark:text-sky-200" : "bg-muted"}`} data-testid={`preview-attachment-${i}`}><Paperclip className="w-3 h-3" />{f.name}</span>
            ))}
          </div>
        )}
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="preview-back-btn"><ChevronLeft className="w-4 h-4 mr-1" /> Retour à l'édition</Button>
          <Button onClick={onConfirm} disabled={sending} data-testid="preview-confirm-send-btn"><Send className="w-4 h-4 mr-1" /> {sending ? "Envoi..." : "Confirmer l'envoi"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default EmailPreviewDialog;
